import React from "react";
import { LOGO_URL } from "@/lib/assets";

export default function Logo({ size = 36, showText = true, textClass = "", accentClass = "text-primary" }) {
  return (
    <div className="flex items-center gap-2.5">
      <img src={LOGO_URL} alt="All In One French" style={{ width: size, height: size }} className="object-contain drop-shadow-sm" />
      {showText && (
        <span className={`font-display font-semibold tracking-tight leading-none ${textClass}`}>
          All In One <span className={accentClass}>French</span>
        </span>
      )}
    </div>
  );
}
